<template>
    <div class="animated fadeIn">
        <b-card>
            <h5><i class="fa fa-fw fa-bullseye mr-2" />Target Kerja</h5>
            <hr />
            <b-form-row>
                <b-col md="2" class="mb-2">
                    <b-form-select id="inputTahun"
                        v-model="filter.year"
                        :options="optYear"
                        @change="getItems"
                    >
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="auto" class="mb-2">
                    <b-button variant="primary" @click="openDownloadModal('Download Rekap Tahunan', 'spk-target/download/')">
                        <i class="fa fa-download mr-2" />Download Rekap Tahunan
                    </b-button>
                </b-col>
                <b-col md="auto" class="mb-2">
                    <b-button variant="dark" @click="openDownloadModal('Download Rekap SPK Aktif', 'report/spk-monthly-active/')">
                        <i class="fa fa-download mr-2" />Download Rekap SPK Aktif
                    </b-button>
                </b-col>
                <b-col md="auto" class="mb-2">
                    <b-button variant="warning" @click="openDownloadModal('Download Rekap Planner', 'report/planner-monthly-installment/')">
                        <i class="fa fa-download mr-2" />Download Rekap Planner
                    </b-button>
                </b-col>
                <b-col md="auto" class="mb-2">
                    <b-button variant="info" @click="openDownloadModal('Download Rekap Install Retur', 'report/install-retur/')">
                        <i class="fa fa-download mr-2" />Download Rekap Install Retur
                    </b-button>
                </b-col>
                <b-col md="auto" class="mb-2">
                    <b-button variant="secondary" @click="openDownloadModal('Download Rekap Saldo', 'report/monthly-recap/')">
                        <i class="fa fa-download mr-2" />Download Rekap Saldo
                    </b-button>
                </b-col>
            </b-form-row>
            <b-table bordered hover show-empty sticky-header
                :busy="isBusy"
                :items="tableItems"
                :fields="fields"
                responsive class="mt-3"
            >
                <template v-slot:empty>
                    Tidak ada data.
                </template>
                <template v-slot:cell()="data">
                    <span v-if="data.field.key == 'kategori'">{{ data.value }}</span>
                    <div v-else class="cell-editable" @click="openEditModal(data.item, data.field.key)">{{ data.value }}</div>
                </template>
            </b-table>
        </b-card>
        <b-modal id="modal-edit-target" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Target">
                <b-form-input type="number" min="0" step="1" v-model.number="editTarget" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeSave">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-download-rekap" :title="downloadTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'spk-target',
    data() {
        return {

            isBusy: false,
            isSubmitting: false,

            filter: {
                year: null
            },

            optYear: [],

            items: [],

            activeItem: null,
            activeMonth: null,
            editTarget: 0,

            downloadStatus: 0,
            downloadPath: "",
            downloadTitle: ""

        }
    },

    computed: {

        fields() {
            let fields = [{ key: "kategori", label: "Kategori" }]
            this.$helper.MONTHS.forEach((name, index) => {
                fields.push({ key: "m" + (index + 1), label: name, tdClass: "p-0" })
            })
            return fields
        },

        tableItems() {

            return this.items.map(it => {

                let row = { categoryId: it.category.id, kategori: it.category.name.replace("_", " ") }

                it.targets.forEach((target, index) => {
                    row["m" + (index + 1)] = target == 0 ? "-" : target
                })

                return row

            })

        },

        modalTitle() {

            if(!this.activeItem) { return "" }

            let categoryName = this.activeItem.category.name.replace("_", " ")
            let monthName = this.$helper.MONTHS[this.activeMonth - 1]

            return `Mengubah Target ${categoryName} ${monthName} ${this.filter.year}`

        }

    },

    created() {

        let currentYear = new Date().getFullYear()

        for(let y = currentYear; y >= 2021; y--) {
            this.optYear.push(y)
        }

        this.filter.year = currentYear
        this.getItems()

    },

    methods: {

        getItems() {

            this.isBusy = true

            this.$axios.get("spk-target/?year=" + this.filter.year).then(res => {

                this.items = res.data

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        openEditModal(row, key) {

            let month = parseInt(key.substring(1))
            let item = this.items.find(it => it.category.id == row.categoryId)

            this.activeItem = item
            this.activeMonth = month
            this.editTarget = item.targets[month - 1]

            this.$bvModal.show("modal-edit-target")

        },

        openDownloadModal(title, endpoint) {

            this.downloadStatus = 1
            this.downloadPath = ""
            this.downloadTitle = title

            this.$bvModal.show("modal-download-rekap")

            this.$axios.get(endpoint + "?year=" + this.filter.year).then(res => {

                this.downloadPath = this.$BASE_FILE_PATH + res.data
                this.downloadStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-rekap")
            })

        },

        executeSave() {

            if(this.$helper.isBlank(this.editTarget) || this.editTarget < 0 || !Number.isInteger(this.editTarget)) {
                this.$helper.toastError(this, "Target harus berupa angka bulat, tidak boleh negatif!")
                return
            }

            let payload = new FormData()
            payload.append("categoryId", this.activeItem.category.id)
            payload.append("month", this.activeMonth)
            payload.append("year", this.filter.year)
            payload.append("target", this.editTarget)

            this.isSubmitting = true

            this.$axios.post("spk-target/", payload).then(res => {

                if(res.status == 200) {
                    this.$set(this.activeItem.targets, this.activeMonth - 1, this.editTarget)
                    this.$bvModal.hide("modal-edit-target")
                    this.$helper.toastSuccess(this, "Target berhasil diubah!")
                }

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        }

    }

}
</script>

<style scoped>
.cell-editable {
    cursor: pointer;
    padding: 0.75rem;
    width: 100%;
    height: 100%;
}
</style>
